// extracted by mini-css-extract-plugin
export default {"logoutBarContainer":"LogoutBar_logoutBarContainer__Xu4gE","link":"LogoutBar_link__Pukif"};